import { render } from "./singlepageheader.vue?vue&type=template&id=6a3a4d7c&scoped=true"
import script from "./singlepageheader.vue?vue&type=script&lang=js"
export * from "./singlepageheader.vue?vue&type=script&lang=js"

import "./singlepageheader.vue?vue&type=style&index=0&id=6a3a4d7c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\amaan\\encanto-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a3a4d7c"]])

export default __exports__